<template>
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="movieTitle"
            label="标题"
            width="300"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="movieSynopsis"
            label="内容"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="coverImage"
            label="视频图片"
            align="center"
            width="160"
          >
          
            <template v-slot="scope">
           
               
               <el-image
               v-if="scope.row.coverImage"
             lazy
                style="width: 78px; height: 78px;border-radius:5px"
                :src="scope.row.coverImage "
                :preview-src-list="strToArray(scope.row.coverImage)"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="play(scope.row)"
                >播放</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="responseData.pageNum"
          :page-size="responseData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      class="video-dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
      :center="true"
    >
      <ckplayer-only
        :ckplayerDialogShow="dialogVisible"
        :isLive="isLive"
        :videoUrl="videoUrl"
        :widthHeigt="[900, 494]"
      ></ckplayer-only>
    </el-dialog>
  </div>
</template>
<script>
import CkplayerOnly from "@/components/CkplayerOnly";
export default {
  name: "schoolRecords",
  components: {
    CkplayerOnly
  },
  props: {},
  data() {
    return {
      req: {
        pageSize: 20,
        pageNum: 1,
        type: 1
      },
      responseData: {
        pageNum: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
        list: []
      },
      dialogTitle: "",
      dialogVisible: false,
      videoUrl: '',
      isLive: false
    };
  },
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  },
  created() {
    this.getClassEducationVideo();
  },
  mounted() {},
  watch: {},
  methods: {
      async getImgUrl(url){
        this.$Common.getPlayUrls(decodeURIComponent(url)).then(res=>{
          
        })
      },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.req.pageSize = val;
      this.getClassEducationVideo();
    },
    play(row) {
      // console.log(row)
      this.dialogTitle = row.movieTitle;
      this.dialogVisible = true;
      let obj = JSON.stringify(row)
  
      this.videoUrl = JSON.parse(obj).videoPath ;
    console.log( decodeURIComponent(this.videoUrl) )
    },
    // 展示教育视频
    async getClassEducationVideo() {
      if (this.eduInfo && this.eduInfo.eduBuresuType == -1) {
        this.req.type = 2;
      } else {
        this.req.type = 1;
      }
      let req = this.req;
      // console.log(req)
      let res = await this.$Http.getClassEducationVideo(req, true);
      // console.log(res);
      if (res.code == 200) {
        res.data.list.forEach(async item=>{
          if(item.coverImage.includes('.myqcloud.com')){

              item.coverImage = await  this.$Common.getPlayUrls(decodeURIComponent(item.coverImage))
          }
        })
        this.$nextTick(()=>{
          setTimeout(() => {
                    this.responseData = res.data;

          }, 800);

        })
        // this.strToArray("a#b#c#d#e");
      } else if (res.code == 101) {
        this.responseData = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    strToArray(str) {
      // console.log(str)
      var arr = str.split("#");
      // console.log(arr);
      return arr;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.sel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}
.el-pagination {
  margin-top: 10px;
}
.video-dialog {
  /deep/ .el-dialog {
    .el-dialog__body {
      padding: 0;
      #video {
        width: 900px;
        height: 494px;
      }
    }
  }
}
</style>
